import {
  createExtension,
  createRouteRef,
  coreExtensionData,
  NavItemBlueprint,
} from '@backstage/frontend-plugin-api';
import { Home } from 'lucide-react';
import { IconComponent } from '@backstage/core-plugin-api';
import { HomePage } from './HomePage';

// Create a route ref for the home page
const homeRouteRef = createRouteRef();

// Create the home page extension
export const HomePageExtension = createExtension({
  kind: 'page',
  name: 'home',
  attachTo: { id: 'app/routes', input: 'routes' },
  output: [
    coreExtensionData.routePath,
    coreExtensionData.routeRef,
    coreExtensionData.reactElement,
  ],
  factory: () => {
    return [
      coreExtensionData.routePath('/'),
      coreExtensionData.routeRef(homeRouteRef),
      coreExtensionData.reactElement(<HomePage />),
    ];
  },
});

// Create the home nav item (optional - for if you want to add a Home item to the nav)
export const homeNavItem = NavItemBlueprint.make({
  name: 'home-nav',
  params: {
    title: 'Home',
    icon: Home as IconComponent,
    routeRef: homeRouteRef,
  },
});